import React, { Component } from 'react'
import PropTypes from 'prop-types'
import I18n from 'translations/i18n'
import className from 'classnames'
import { ReactComponent as ClearIcon } from 'assets/images/icons/clear-24px.svg'

class SearchFilter extends Component {
  state = {
    search: this.props.initvalue || '',
  }

  componentWillUnmount() {
    clearTimeout(this.typingTimer)
  }

  handleKeyDown = () => {
    clearTimeout(this.typingTimer)
  }

  handleKeyUp = () => {
    clearTimeout(this.typingTimer)
    this.typingTimer = setTimeout(this.handleSubmitFilter, 1000)
  }

  handleSearch = (event) => {
    this.setState({
      search: event.target.value,
    })
  }

  handleSubmitFilter = () => {
    clearTimeout(this.typingTimer)
    const { onSubmit } = this.props
    if (onSubmit) {
      onSubmit({ search: this.state.search })
    }
  }

  render() {
    const { search } = this.state
    const { style, version, placeholder, testId } = this.props

    return (
      <div
        className={className(
          'jisr-form-group',
          'header-option-search',
          version && `version-${version}`,
        )}
      >
        <input
          data-testid={testId}
          disabled={this.props.fetching}
          value={search}
          placeholder={placeholder || I18n.t('search_placeholder')}
          onChange={this.handleSearch}
          onKeyDown={this.handleKeyDown}
          onKeyUp={this.handleKeyUp}
          style={style}
        />
        {!!search && (
          <ClearIcon
            onClick={() => {
              this.setState({ search: '' }, this.handleSubmitFilter)
            }}
          />
        )}
      </div>
    )
  }
}

SearchFilter.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  fetching: PropTypes.bool,
  initvalue: PropTypes.string,
  version: PropTypes.string,
  placeholder: PropTypes.string,
  testId: PropTypes.string,
  style: PropTypes.shape(),
}

export default SearchFilter
